/*
 * @Author: Ryan
 * @Date: 2025-12-03
 * @Description: Hero section with background image and glass-morphism button
 */
import { Button } from 'antd';
import Image from 'next/image';
import React from 'react';

import { scrollToTop } from '@/utils/landing/scrollToTop';

const HeroSection: React.FC = () => {
  const handleTranslateClick = () => {
    scrollToTop();
  };

  return (
    <section className="relative w-full h-[478px] bg-[#0A0A0A]">
      {/* 背景图片 */}
      <div className="absolute inset-0 z-0">
        <Image
          src="/images/landing-make-bg.png"
          alt="FalcoCut AI Video Translator"
          fill
          className="object-contain"
          priority
        />
        {/* 深色遮罩层 - 可选，用于提升文字可读性 */}
        <div className="absolute inset-0 bg-black/30" />
      </div>

      {/* 内容区域 */}
      <div className="relative z-10 h-full flex items-center justify-center px-4 pad:px-8 sm:px-[65px]">
        <div className="max-w-[1190px] w-full text-center">
          {/* 主标题 */}
          <h2 className="text-3xl pad:text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-4 pad:mb-6 sm:mb-8 leading-tight">
            Make Your Videos Speak Every Language
          </h2>

          {/* 描述文本 */}
          <p className="text-base pad:text-lg sm:text-xl text-white/90 mb-8 pad:mb-10 sm:mb-12 max-w-4xl mx-auto leading-relaxed">
            With FalcoCut AI Video Translator, you can translate videos into 35+
            languages, add subtitles, clone voices, and sync lips in minutes. Scale your
            content globally and connect with audiences like never before.
          </p>

          {/* 玻璃态按钮 */}
          <Button
            type="primary"
            size="large"
            onClick={handleTranslateClick}
            className="glass-button"
            style={{
              background:
                'linear-gradient(282.25deg, rgba(0, 13, 255, 0.2312) -57.11%, rgba(255, 255, 255, 0.34) 37.77%, rgba(136, 49, 250, 0.2006) 165.68%)',
              border: '1px solid #B9B9B9',
              backdropFilter: 'blur(19px)',
              WebkitBackdropFilter: 'blur(19px)',
              height: 'auto',
              padding: '14px 40px',
              fontSize: '18px',
              fontWeight: 600,
              borderRadius: '50px',
              boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37)',
            }}
          >
            Translate Video Now
          </Button>
        </div>
      </div>

      {/* 添加全局样式来处理按钮 hover 效果 */}
      <style jsx global>{`
        .glass-button:hover {
          background: linear-gradient(
            282.25deg,
            rgba(0, 13, 255, 0.35) -57.11%,
            rgba(255, 255, 255, 0.5) 37.77%,
            rgba(136, 49, 250, 0.3) 165.68%
          ) !important;
          border-color: #ffffff !important;
          transform: translateY(-2px);
          box-shadow: 0 12px 40px 0 rgba(31, 38, 135, 0.5) !important;
        }

        .glass-button:active {
          transform: translateY(0);
        }

        .glass-button {
          transition: all 0.3s ease;
        }
      `}</style>
    </section>
  );
};

export default HeroSection;
